<app-nav-bar [ngStyle]="{'overflow': 'auto'}" [drawerTitle]="title" [user]="(user | async)" >
  <router-outlet></router-outlet>
</app-nav-bar>
